import styled, { keyframes } from 'styled-components';

const slideIn = keyframes`
  from { transform: translateY(-20px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
`;

export const Overlay = styled.div`
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  z-index: 1000;
`;

export const ModalCard = styled.div`
  background: white;
  width: 100%;
  max-width: 500px;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0,0,0,0.2);
  overflow: hidden;
  border-top: 6px solid #dc3545;
  animation: ${slideIn} 0.3s ease-out;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
`;

export const Header = styled.div`
  padding: 24px 24px 0;
  text-align: center;
`;

export const AlertIcon = styled.span`
  color: #dc3545;
  font-size: 48px;
  margin-bottom: 16px;
  display: block;
`;

export const Title = styled.h2`
  color: #1a1a1a;
  font-size: 24px;
  font-weight: 700;
  margin: 0 0 8px 0;
`;

export const Body = styled.div`
  padding: 16px 24px;
  color: #4a4a4a;
  font-size: 16px;
  line-height: 1.5;
`;

export const WarningBox = styled.div`
  background-color: #fff5f5;
  border: 1px solid #ffe3e3;
  border-radius: 8px;
  padding: 16px;
  margin: 16px 0;

  ul {
    margin-left: 20px;
    margin-top: 8px;
  }

  li {
    margin-bottom: 4px;
  }
`;

export const DangerText = styled.p`
  color: #dc3545;
  font-weight: 700;
  margin-bottom: 20px;
`;

export const InputWrapper = styled.div`
  margin-top: 20px;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #333;
`;

export const Input = styled.input`
  width: 100%;
  padding: 12px;
  border: 2px solid #ddd;
  border-radius: 6px;
  font-size: 16px;
  transition: border-color 0.2s;
  text-transform: uppercase;
  outline: none;

  &:focus {
    border-color: #dc3545;
  }
`;

export const Footer = styled.div`
  padding: 24px;
  background-color: #f9f9f9;
  display: flex;
  gap: 12px;
  justify-content: flex-end;
`;

const ButtonBase = styled.button`
  padding: 12px 20px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: all 0.2s;
`;

export const CancelButton = styled(ButtonBase)`
  background-color: #e9ecef;
  color: #495057;

  &:hover {
    background-color: #dee2e6;
  }
`;

export const DeleteButton = styled(ButtonBase)`
  background-color: #dc3545;
  color: white;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:not(:disabled):hover {
    background-color: #c82333;
  }
`;